import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-rating-box',
  templateUrl: './rating-box.component.html',
  styleUrls: ['./rating-box.component.scss']
})
export class RatingBoxComponent implements OnInit {
  @Input() rating : number|any = 0;
  @Input() backgroundColor : string = 'unset';
  @Input() class : string = 'text-right';
  @Input() border : string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
